"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonApiFetch = void 0;
// @file utilities for json api
var fetch_1 = require("@padlet/fetch");
var types_1 = require("@padlet/fetch/lib/types");
var configure_1 = require("./configure");
function versionedJsonApiPathWithLeadingSlash(path) {
  var jsonApiVersion = (0, configure_1.getConfiguration)().jsonApiVersion;
  var pathWithLeadingSlash = path.startsWith('/') ? path : "/" + path;
  return "/api/" + jsonApiVersion + pathWithLeadingSlash;
}
function jsonApiFetch(path) {
  var options = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    options[_i - 1] = arguments[_i];
  }
  return __awaiter(this, void 0, void 0, function () {
    var _a, jsonApiHost, oauthToken, moreOptions, url;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, (0, configure_1.deferredGetConfiguration)()];
        case 1:
          _a = _b.sent(), jsonApiHost = _a.jsonApiHost, oauthToken = _a.token.oauthToken;
          moreOptions = {
            mode: types_1.FetchOptionMode.cors,
            credentials: types_1.FetchOptionCredentials.omit
          };
          if (oauthToken) {
            moreOptions.authorization = [fetch_1.HTTPAuthenticationScheme.bearer, oauthToken];
          }
          url = "https://" + jsonApiHost + versionedJsonApiPathWithLeadingSlash(path);
          return [2 /*return*/, fetch_1.fetchJson.apply(void 0, __spreadArray([url, moreOptions], options, false))];
      }
    });
  });
}
exports.jsonApiFetch = jsonApiFetch;